import { Host, Component, h, Prop } from '@stencil/core';


@Component({
    tag: 'lilu-cms-content',
    styleUrl: 'lilu-cms-content.scss',
    scoped: true
})
export class LiluCmsContent {
  @Prop() appearance: '' | 'info' = '';
  @Prop() contentHeigth: '' | 'limited' = '';
  @Prop() isOverflowing: boolean = false;
  @Prop() isOpen: boolean = false;
  @Prop() config: string;

  componentDidLoad() {
    if(this.appearance === 'info') {
      const containerHeight = document.querySelector<HTMLElement>('.cms-content').offsetHeight;
      if(containerHeight > 120) {
        this.isOverflowing = true;
        this.contentHeigth = 'limited';
      }
    }
  }

  handleClick() {
    this.isOverflowing = !this.isOverflowing;
    this.isOpen = !this.isOpen;
  }

  render() {
    return (
      <Host appearance={this.appearance}>
        <div class={`cms-content ${this.config} ${this.contentHeigth} ${this.isOpen ? '' : 'closed'}`} >
          <slot></slot>
        </div>
        {this.contentHeigth === 'limited'  && (
          <div class={`link ${this.isOpen ? '' : 'closed'}`}>
            <lilu-p
              appearance="underline"
              icon=""
              size="size-18"
              onClick={() => this.handleClick()}
            >
              {this.isOpen ? 'weniger anzeigen' : 'mehr erfahren'}
            </lilu-p>
          </div>
        )}
      </Host>
    );
  }
}
